export default "__VITE_ASSET__CXnAprFE__"